<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     设备详情-监控-设备分享
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog class="equip-share" :visible.sync="dialogShow" width="1200px" :modal-append-to-body="false" :close-on-click-modal="false" :append-to-body="true" @closed="dialogClose" @open="dialogOpen">
    <div slot="title" class="flex align-items-center" style="justify-content: space-between">
      <span class="font-lg">设备分享</span>
      <el-popover placement="bottom-start" trigger="hover">
        <li>
          <el-link href="https://wiki.frippler.com/#/docs/fs/fcs/16" target="_blank">快速分享一台设备 </el-link>
        </li>
        <li class="mt-sm">
          <el-link href="https://wiki.frippler.com/#/docs/fs/fcs/16" target="_blank">什么是归属权？移交归属权</el-link>
        </li>
        <span slot="reference" role="button" class="text-warning mr-hg flex-center"><span class="iconfont icon-circle-question font-lg"></span>设备分享操作指南 </span>
      </el-popover>
    </div>
    <el-steps :active="currentStep" finish-status="success" process-status="success" simple style="margin: 0 30px 30px">
      <el-step title="选择分享对象" />
      <el-step title="设置权限" />
      <el-step title="分享结果" />
    </el-steps>

    <div class="main-body flex-center" style="margin: 0 150px">
      <div v-show="!currentStep" style="width: 100%">
        <div class="toolbox mb">
          <el-select v-model="keyword" placeholder="搜索用户" style="width: 240px" :clearable="true" autocomplete="off" filterable remote :remote-method="remoteMethod" @change="onSelectChange">
            <div v-if="options.friends && options.friends.length">
              <div class="option-title">
                <div class="option-title-bar"></div>
                <div class="ml-xs">我的好友</div>
              </div>
              <el-option v-for="item in options.friends" :key="item.id" :label="item.name" :value="item.id">
                <f-image class="avatar circle mini" :src="item.avatar ? item.avatar : require('@/assets/default-avatar.png')" />
                <span class="ml-sm">{{ item.name }}</span>
                <span class="ml-sm text-muted">{{ item.remark }}</span>
              </el-option>
            </div>
            <div v-if="options.users && options.users.length">
              <div class="option-title">
                <div class="option-title-bar"></div>
                <div class="ml-xs">PC用户</div>
              </div>
              <el-option v-for="item in options.users" :key="item.friendid" :label="item.name" :value="item.friendid">
                <f-image class="avatar circle mini" :src="item.avatar ? item.avatar : require('@/assets/default-avatar.png')" />
                <span class="ml-sm">{{ item.name }}</span>
                <span class="ml-sm text-muted">{{ item.remark }}</span>
              </el-option>
            </div>
            <div v-if="options.members && options.members.length">
              <div class="option-title">
                <div class="option-title-bar"></div>
                <div class="ml-xs">小程序用户</div>
              </div>
              <el-option v-for="item in options.members" :key="item.friendid" :label="item.name" :value="item.friendid">
                <f-image class="avatar circle mini" :src="item.avatar ? item.avatar : require('@/assets/default-avatar.png')" />
                <span class="ml-sm">{{ item.name }}</span>
                <span class="ml-sm text-muted">{{ item.remark }}</span>
              </el-option>
            </div>
          </el-select>
        </div>
        <el-table :data="currentFriends" tooltip-effect="dark" style="width: 100%" class="padding-large" max-height="400" @row-click="clickRow">
          <el-table-column label="头像" width="80">
            <template slot-scope="scope">
              <f-image class="avatar rounded larger" :src="scope.row.avatar ? scope.row.avatar : require('@/assets/default-avatar.png')" />
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="用户信息" min-width="180">
            <template slot-scope="scope">
              <div class="flex align-items-center">
                <span>{{ scope.row.name }}</span>
                <el-tooltip effect="dark" content="PC用户" placement="top">
                  <span role="button" v-if="scope.row.friend_type == 1" style="width: 20px; height: 20px" class="iconfont text-success ml-sm">&#xe692;</span>
                </el-tooltip>
                <el-tooltip effect="dark" content="小程序用户" placement="top">
                  <span role="button" v-if="scope.row.friend_type == 2" style="width: 20px; height: 20px" class="iconfont text-success ml-sm">&#xe693;</span>
                </el-tooltip>
              </div>
              <div class="text-muted">{{ scope.row.remark }}</div>
            </template>
          </el-table-column>
          <el-table-column label="" width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.id === activeid" class="iconfont text-success font-3x">&#xe694;</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-show="currentStep === 1" v-loading="shareLoading" style="width: 100%">
        <div class="toolbox mb">
          <el-select v-model="user_auth" placeholder="设置权限" style="width: 160px" :clearable="true" @change="onAuthChange">
            <el-option v-for="auth in authArr" :key="auth.key" :label="auth.value" :value="auth.key"> </el-option>
          </el-select>
        </div>
        <el-table :data="currentEquips" tooltip-effect="dark" style="width: 100%; min-height: 225px" class="padding-large" max-height="400">
          <el-table-column type="index" width="50" />
          <el-table-column :show-overflow-tooltip="true" label="设备名称" prop="name" min-width="140" />
          <el-table-column label="设置权限" min-width="120" align="center">
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="selectShareAuth">
                <span class="el-dropdown-link"> {{ authObj[scope.row.auth_level].value }}<i class="el-icon-arrow-down el-icon--right" /> </span>
                <el-dropdown-menu slot="dropdown">
                  <template v-for="auth in authArr">
                    <el-dropdown-item v-if="auth.key <= scope.row.user_auth" :key="auth.key" :disabled="scope.row.deliver ? true : false" :command="{ equip: scope.row, rank: auth.key }"> {{ auth.value }} </el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <el-table-column v-if="activetype === 1" label="移交归属权" min-width="120" align="center">
            <template slot-scope="scope">
              <el-switch
                v-if="scope.row.owner_auth"
                v-model="scope.row.deliver"
                :active-value="1"
                :inactive-value="0"
                active-color="#07c160"
                inactive-color="#dddddd"
                :disabled="scope.row.owner_auth ? false : true"
                @change="transfer(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column v-if="currentEquips.length > 1" label="" width="60">
            <template slot-scope="scope">
              <el-link class="hover-show" :underline="false" icon="el-icon-circle-close" @click="deleteRow(scope.row)"></el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-show="currentStep === 2" style="width: 100%" class="mt-lg mb-lg">
        <div class="flex-center font-lg mb-lg">
          <span
            >操作成功！<span
              >共 <span class="font-2x text-success"> {{ success_num }}</span
              >{{ '台设备分享成功' }}</span
            ><span v-if="failarr.length"
              >，共 <span class="font-2x text-danger"> {{ fail_num }}</span
              >{{ '台设备分享失败' }}</span
            ></span
          >
        </div>
        <div v-if="failarr.length" class="flex-center">
          <div style="width: 600px">
            <el-table :data="failarr" tooltip-effect="dark" style="width: 100%" class="padding-large" max-height="225" @row-click="clickRow">
              <el-table-column type="index" width="50" />
              <el-table-column :show-overflow-tooltip="true" label="分享失败设备" prop="equip_name" min-width="160" />
              <el-table-column :show-overflow-tooltip="true" label="失败原因" prop="message" min-width="120" />
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer flex-center">
      <el-button v-show="currentStep === 1" @click="currentStep = 0">上一步</el-button>
      <el-button v-show="currentStep === 0" type="primary" :disabled="!activeid" @click="dealAuth()">下一步</el-button>
      <el-button v-show="currentStep === 1" :disabled="!activeid || shareLoading" type="primary" plain @click="submit">分 享</el-button>
      <el-button v-show="currentStep === 2" type="primary" @click="dialogShow = false">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Vue from 'vue'
import { equipShareApi } from '@/api/rms/rmsEquipShareApi'
import { getFriendApi, serachFriendApi, addFriendApi } from '@/api/fam/famFriendApi'

export default {
  name: 'RmsEquipShare',

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false
    },
    equips: {
      type: Array,
      default: undefined
    }
  },

  data() {
    return {
      basic_auth: this.$store.state.userStore,
      currentStep: 0,
      user_auth: null,
      response: [],
      currentEquips: [],

      authArr: [
        { key: 1, value: '用户' },
        { key: 2, value: '用户管理员' },
        { key: 3, value: '工程商' },
        { key: 4, value: '经销商' },
        { key: 5, value: '厂商' }
      ],
      authObj: {
        1: { value: '用户' },
        2: { value: '用户管理员' },
        3: { value: '工程商' },
        4: { value: '经销商' },
        5: { value: '厂商' }
      },

      loading: false,
      shareLoading: false,
      friendsLoading: false,
      friends: [],
      currentFriends: [],
      options: {},
      keyword: '',
      activeid: null,
      activetype: null,

      lasttime: 0 // 防抖
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    },

    success_num() {
      let arr = []
      arr = this.response.filter(item => item.result)
      return arr.length
    },

    fail_num() {
      let arr = []
      arr = this.response.filter(item => !item.result)
      return arr.length
    },

    failarr() {
      let arr = []
      arr = this.response.filter(item => !item.result)
      return arr
    }
  },

  watch: {},

  created() {
    // this.fetchFriend()
  },

  methods: {
    fetchFriend() {
      this.friendsLoading = true
      getFriendApi().then(res => {
        this.friendsLoading = false
        if (res.errno === 0) {
          this.friends = res.data.list
          this.currentFriends = this.friends
        } else {
          this.$message.error(res.message)
        }
      })
    },

    clickRow(row) {
      this.activeid = row.id
      this.activetype = row.friend_type
    },

    dealAuth() {
      const arr = this.equips
      if (arr.length) {
        arr.forEach((v, i) => {
          Vue.set(arr[i], 'deliver', 0)
          if (this.activetype === 1) {
            Vue.set(arr[i], 'auth_level', v.user_auth === 10 ? 5 : v.user_auth === 1 ? 1 : v.user_auth - 1)
          } else if (this.activetype === 2) {
            Vue.set(arr[i], 'auth_level', 1)
          }
        })
      }
      this.currentEquips = arr
      this.currentStep = 1
    },

    dialogOpen() {
      this.fetchFriend()
    },

    dialogClose() {
      this.keyword = ''
      this.options = {}
      this.currentStep = 0
      this.activeid = 0
      this.activetype = null
      this.response = []
    },

    remoteMethod(query) {
      if (query !== '') {
        this.options = {}
        serachFriendApi({ keyword: query })
          .then(res => {
            if (!res.errno) {
              this.options = res.data
            } else {
              this.$message.error(res.message)
            }
          })
          .catch(() => {})
      } else {
        this.options = {}
      }
    },

    onAuthChange(val) {
      if (!val) return
      if (this.currentEquips.length) {
        this.currentEquips.forEach((v, i) => {
          if (!v.deliver && val <= v.user_auth) {
            Vue.set(this.currentEquips[i], 'auth_level', v.user_auth < val ? v.user_auth : val)
          }
        })
      }
    },

    onSelectChange(val) {
      if (!val) {
        this.currentFriends = this.friends
        return
      }
      const ids = this.friends.map(item => item.id)
      if (ids.indexOf(val) > -1) {
        this.currentFriends = this.friends.filter(item => item.id === val)
        this.activeid = val
        this.activetype = this.currentFriends[0].friend_type
        return
      }
      let tmp = []
      const userFriendids = this.options.users.map(item => item.friendid)
      const memberFriendids = this.options.members.map(item => item.friendid)
      if (userFriendids.indexOf(val) > -1) {
        tmp = this.options.users.filter(item => item.friendid === val)
      }
      if (memberFriendids.indexOf(val) > -1) {
        tmp = this.options.members.filter(item => item.friendid === val)
      }
      this.$confirm(`立即添加 <span class="font-lg text-success">${tmp[0].name}</span> 为企业好友，是否继续？`, '提示', {
        type: 'warning',
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          addFriendApi({
            friend_type: tmp[0].friend_type,
            friendid: tmp[0].friendid
          }).then(res => {
            if (res.errno === 0) {
              this.fetchFriend()
              this.activeid = Number(res.data.id)
              this.activetype = Number(res.data.friend_type)
              this.keyword = ''
              this.options = {}
              this.$message.success('企业好友添加成功')
            } else {
              this.$message.error(res.message)
            }
          })
        })
        .catch(() => {})
    },

    deleteRow(row) {
      this.currentEquips = this.currentEquips.filter(item => item.equipid !== row.equipid)
    },

    selectShareAuth(command) {
      Vue.set(this.currentEquips[this.currentEquips.indexOf(command.equip)], 'auth_level', command.rank)
      this.user_auth = null
    },

    transfer(row) {
      if (row.deliver) {
        Vue.set(this.currentEquips[this.currentEquips.indexOf(row)], 'auth_level', 5)
      }
    },

    submit() {
      let nowtime = new Date().getTime()
      if (nowtime - this.lasttime > 1000 && !this.shareLoading) {
        // 防抖
        this.shareLoading = true
        this.lasttime = nowtime
        const array = []
        this.currentEquips.forEach((v, i) => {
          array.push({ equipid: v.equipid, deliver: v.deliver, auth_level: v.auth_level })
        })
        const temp = {
          id: this.activeid,
          data: array
        }
        equipShareApi(temp).then(res => {
          this.shareLoading = false
          if (res.errno === 0) {
            this.currentStep = 2
            this.response = res.data
            this.$emit('change')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.el-table tr {
  height: 45px;
}
.el-dialog__body {
  padding: 10px 20px;
}
.el-dialog__footer {
  padding: 10px 20px;
}
.el-dropdown-menu__item {
  min-width: 104px;
}

.option-title {
  margin: 0 0 0 20px;
  padding: 5px 0;
  color: #07c160;
  display: flex;
  align-items: center;
  .option-title-bar {
    width: 3px;
    height: 12px;
    border-radius: 3px;
    background-color: #07c160;
  }
}

/*滚动条的宽度*/
::-webkit-scrollbar {
  width: 6px; // 横向滚动条
  height: 6px; // 纵向滚动条 必写
}
/*滚动条的滑块*/
::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
</style>
